<template>
    <modal id="status-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('status')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/status`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div v-if="!hotel_id" class="col-md-12">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('hotel')"
                        list-value-field="name"
                        v-model="formData.hotel_id"
                        :chooseLabel="$t('hotel')"
                        :error-message="$errorMessage(errors, 'hotel_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="time"
                        :label="$t('arrived_time')"
                        v-model="formData.arrived_time"
                        :error-message="$errorMessage(errors, 'arrived_time')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('date')"
                        v-model="formData.date"
                        :placeholder="formData.date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('room')"
                        list-value-field="name"
                        v-model="formData.room_id"
                        :chooseLabel="$t('room')"
                        :error-message="$errorMessage(errors, 'room_id')"
                        :fetch-url="room_url"
                        @change="updatePrice()"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('staying')"
                        list-value-field="name"
                        v-model="formData.staying_id"
                        :chooseLabel="$t('staying')"
                        :error-message="$errorMessage(errors, 'staying_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/staying?hotel_id=${hotel_id}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('cleaning')"
                        list-value-field="name"
                        v-model="formData.cleaning_id"
                        :chooseLabel="$t('cleaning')"
                        :error-message="$errorMessage(errors, 'cleaning_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/cleaning?hotel_id=${hotel_id}`"
                        @change="updatePrice()"
                    />
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-light">
                                <tr>
                                    <th style="min-width: 150px;">{{ $t('option') }}</th>
                                    <th style="min-width: 100px;">{{ $t('quantity') }}</th>
                                    <th style="min-width: 150px;">{{ $t('contract_price') }}</th>
                                    <th style="min-width: 150px;">{{ $t('selling_price') }}</th>
                                    <th style="min-width: 50px;" class="text-end text-nowrap">{{ $t('action') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="options">
                                    <tr v-for="(option, index) in options">
                                        <td>
                                            <input type="hidden" v-model="option.name">
                                            <app-form-group
                                                type="select"
                                                :label="$t('option')"
                                                list-value-field="name"
                                                v-model="option.id"
                                                :chooseLabel="$t('option')"
                                                :list="optionList"
                                                @change="changeOption(index, $event.target.value)"
                                            />
                                        </td>
                                        <td>
                                            <app-form-group
                                                type="number"
                                                :label="$t('quantity')"
                                                :placeholder="$placeholder('quantity')"
                                                @change="changeQuantity(index, $event.target.value)"
                                                v-model="option.quantity">
                                            </app-form-group>
                                        </td>
                                        <td>
                                            <app-form-group
                                                type="number"
                                                :label="$t('contract_price')"
                                                :placeholder="$placeholder('contract_price')"
                                                v-model="option.contract_price">
                                            </app-form-group>
                                        </td>
                                        <td>
                                            <app-form-group
                                                type="number"
                                                :label="$t('selling_price')"
                                                :placeholder="$placeholder('selling_price')"
                                                v-model="option.selling_price">
                                            </app-form-group>
                                        </td>
                                        <td class="text-center">
                                            <a href="#" @click="deleteOption(index)" class="btn text-danger px-0">
                                                <app-icon name="trash-2"/>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="options.length === 0">
                                        <td colspan="100">{{ $t('No data found.') }}</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary" @click="addOption">
                            {{ $t('Add new') }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
.form-group table td > .form-group > label {
    display : none;
}

.form-group table td > .form-group {
    margin-bottom : 0;
}
</style>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {
    formatDateForServer,
    formatTimeForServer, formatTimeToLocal,
    formatUtcToLocal,
    today
} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "StatusCreateEditModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        hotel_id: null,
        room_id : null,
    },
    data() {
        return {
            TENANT_BASE_URL,
            optionList: [],
            options   : [],
            room_url  : null,
            formData  : {
                hotel_id      : this.hotel_id ? this.hotel_id : null,
                room_id       : this.room_id ? this.room_id : null,
                arrived_time  : null,
                date          : formatDateForServer(today()),
                contract_price: null,
                selling_price : null,
            },
        }
    },
    watch  : {
        'formData.hotel_id': {
            handler  : function (value) {
                const hotel_id = value && typeof value !== "undefined" ? value : 0
                this.room_url  = `${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${hotel_id}`

                axiosGet(`${TENANT_BASE_URL}selectable/hotel/option?hotel_id=${hotel_id}`).then(({data}) => {
                    this.optionList = data
                }).catch((error) => {
                    this.$toastr.e(error.response.data.message)
                }).finally(() => {
                    this.errors = {};
                })
            },
            immediate: true
        },
    },
    methods: {
        submitData() {
            this.loading = true
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.options.length > 0) {
                formData.set('options', JSON.stringify(this.options))
            }

            formData.set('date', formatDateForServer(this.formData.date))
            formData.set('arrived_time', formatTimeForServer(this.formData.arrived_time))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {
                hotel_id: this.hotel_id ? this.hotel_id : null,
                date    : formatDateForServer(today()),
            };
            $('#status-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'status-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader             = false;
            this.formData              = response.data;
            this.options               = response.data.options || [];
            this.formData.arrived_time = formatTimeToLocal(response.data.arrived_time);
        },
        updatePrice() {
            if (this.formData.room_id && this.formData.cleaning_id && this.formData.hotel_id) {
                axiosGet(`${TENANT_BASE_URL}selectable/hotel/pricing?hotel_id=${this.formData.hotel_id}&room_id=${this.formData.room_id}&cleaning_id=${this.formData.cleaning_id}`)
                    .then(({data}) => {
                        if (data.length && data[0].contract_price) {
                            this.formData.contract_price = parseInt(data[0].contract_price)
                            this.formData.selling_price  = parseInt(data[0].selling_price)
                        } else {
                            this.formData.contract_price = null
                            this.formData.selling_price  = null
                        }
                    })
                    .catch(error => this.$toastr.e(error.response.data.message))
            } else {
                this.formData.contract_price = null
                this.formData.selling_price  = null
            }
        },
        deleteOption(index) {
            this.options.splice(index, 1)
        },
        addOption() {
            this.options.push({
                id            : null,
                name          : null,
                quantity      : 1,
                contract_price: null,
                selling_price : null,
            })
        },
        changeQuantity(index, value) {
            if (this.options[index].id) {
                this.changeOption(index, this.options[index].id)
            }
        },
        changeOption(index, value) {
            const hasOption = this.options.filter(e => e.id === value)

            if (hasOption.length > 1) {
                this.options[index].id             = 0
                this.options[index].name           = null
                this.options[index].contract_price = null
                this.options[index].selling_price  = null
            } else {
                axiosGet(`${TENANT_BASE_URL}selectable/hotel/option?id=${value}`).then(({data}) => {
                    if (data.id) {
                        this.options[index].contract_price = parseInt(data.contract_price) * this.options[index].quantity
                        this.options[index].selling_price  = parseInt(data.selling_price) * this.options[index].quantity
                        this.options[index].name           = data.name
                    } else {
                        this.options[index].contract_price = null
                        this.options[index].selling_price  = null
                        this.options[index].name           = null
                    }
                }).catch(error => {
                    this.$toastr.e(error.response.data.message)
                })
            }
        },
    },
}
</script>

